import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from "react";
import CustomCard from "../../UI/CustomCard/CustomCard";
import PersonPopulationMembersSharedWithTable from "../../Presentational/Population/PersonPopulationMembersSharedWithTable";
import PopulationService from "../../../Services/Population.service";
import useService from "../../Hooks/useService";
import ServiceResult from "../../UI/ServiceResult/ServiceResult";
const SharedUsersCard = ({ populationId }) => {
    const [sharedWithPeopleState, loadSharedWithPeople] = useService(PopulationService.getPeopleSharedWith);
    useEffect(() => {
        loadSharedWithPeople({ populationId, max: 50, offset: 0 });
    }, [populationId, loadSharedWithPeople]);
    return (_jsx(ServiceResult, { state: sharedWithPeopleState, children: (result) => (_jsx(CustomCard, { className: "mb-3", title: `Shared With (${result.total})`, children: _jsx("div", { className: "card-body", children: _jsx(PersonPopulationMembersSharedWithTable, { populationId: populationId }) }) })) }));
};
export default SharedUsersCard;
